/** UUID estable de la clasificación Proyecto. El contrato no publica una bandera. */
export const WAREHOUSE_PROJECT_CLASSIFICATION_UUID =
  '3cc5f3b3-725a-42a0-8c17-b7ccfb168e28';

export type WarehouseSelectDto = {
  uuid: string;
  name: string;
};

export type WarehouseToneDto = {
  name: string;
  value: string;
  tone: string;
};

export type WarehouseGridDto = {
  uuid: string;
  name: string;
  type: WarehouseSelectDto;
  classification: WarehouseSelectDto;
  project: WarehouseSelectDto | null;
  description: string | null;
  status: WarehouseToneDto;
};

export type WarehouseDto = WarehouseGridDto & {
  createdAt: string;
  updatedAt: string;
};

export type WarehouseRequest = {
  name: string;
  typeUuid: string;
  classificationUuid: string;
  projectUuid: string | null;
  description: string | null;
};

export type WarehouseListQuery = {
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
  name?: string;
  description?: string;
  typeUuids?: readonly string[];
  classificationUuids?: readonly string[];
  projectUuids?: readonly string[];
  statusUuids?: readonly string[];
};

export type WarehouseListResult = {
  items: WarehouseGridDto[];
  total: number;
};

export type WarehouseFormSelects = {
  types: WarehouseSelectDto[];
  classifications: WarehouseSelectDto[];
  projects: WarehouseSelectDto[];
};

export type WarehouseFilterSelects = WarehouseFormSelects & {
  statuses: WarehouseSelectDto[];
};

export type WarehouseApiDownload = {
  blob: Blob;
  filename: string;
};
